export const OPEN_ASSEMBLY_TREE = {
  START: 'OPEN_ASSEMBLY_TREE_PERF_UI_START',
  FINISH: 'OPEN_ASSEMBLY_TREE_PERF_UI_FINISH',
  MEASURE: 'OPEN_ASSEMBLY_TREE_PERF_UI',
};

export const EXPAND_QUOTE_ITEM = {
  START: 'EXPAND_QUOTE_ITEM_PERF_UI_START',
  FINISH: 'EXPAND_QUOTE_ITEM_PERF_UI_FINISH',
  MEASURE: 'EXPAND_QUOTE_ITEM_PERF_UI',
};

export const COLLAPSE_QUOTE_ITEM = {
  START: 'COLLAPSE_QUOTE_ITEM_PERF_UI_START',
  FINISH: 'COLLAPSE_QUOTE_ITEM_PERF_UI_FINISH',
  MEASURE: 'COLLAPSE_QUOTE_ITEM_PERF_UI',
};

export const EXPAND_COMPONENT = {
  START: 'EXPAND_COMPONENT_PERF_UI_START',
  FINISH: 'EXPAND_COMPONENT_PERF_UI_FINISH',
  MEASURE: 'EXPAND_COMPONENT_PERF_UI',
};

export const COMPONENT_BASIC_UPDATE = {
  START: 'COMPONENT_BASIC_UPDATE_PERF_START',
  FINISH: 'COMPONENT_BASIC_UPDATE_PERF_FINISH',
  MEASURE: 'COMPONENT_BASIC_UPDATE_PERF',
};

export const SWITCH_TO_FLAT_BOM = {
  START: 'SWITCH_TO_FLAT_BOM_PERF_UI_START',
  FINISH: 'SWITCH_TO_FLAT_BOM_PERF_UI_FINISH',
  MEASURE: 'SWITCH_TO_FLAT_BOM_PERF_UI',
};

export const LOAD_BAQ = {
  START: 'LOAD_BAQ_PERF_UI_START',
  FINISH: 'LOAD_BAQ_PERF_UI_FINISH',
  MEASURE: 'LOAD_BAQ_PERF_UI',
};
